import { LANGS, SITE_LANGS } from './constants';
export { anyLocalizedText, localizedText } from './i18n-schemas';

const FALLBACK_CHAIN = {
  ru: ["ru", "en", "tr", "tm"],
  en: ["en", "ru", "tr", "tm"],
  tr: ["tr", "en", "ru", "tm"],
  tm: ["tm", "ru", "en", "tr"]
};
function pickLocale(value, lang, chain = FALLBACK_CHAIN[lang]) {
  if (value == null) return "";
  for (const candidate of chain) {
    const text = value[candidate];
    if (typeof text === "string" && text.trim() !== "") return text;
  }
  for (const candidate of LANGS) {
    const text = value[candidate];
    if (typeof text === "string" && text.trim() !== "") return text;
  }
  return "";
}
function isEmptyLocale(value) {
  return pickLocale(value, "ru") === "";
}
function translatedLangs(site, value) {
  if (value == null) return [];
  return SITE_LANGS[site].filter((lang) => {
    const text = value[lang];
    return typeof text === "string" && text.trim() !== "";
  });
}
function plural(forms, count, lang) {
  const category = new Intl.PluralRules(lang).select(count);
  const byCategory = forms;
  const template = byCategory[category] ?? forms.other;
  return template.replace("{count}", String(count));
}
function fill(template, values) {
  return template.replace(
    /\{(\w+)\}/g,
    (whole, name) => name in values ? String(values[name]) : whole
  );
}

export { FALLBACK_CHAIN, fill, isEmptyLocale, pickLocale, plural, translatedLangs };
//# sourceMappingURL=i18n.js.map
//# sourceMappingURL=i18n.js.map